var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterWhitebk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FCFCF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5713 18.6966C31.9284 18.9645 31.2856 19.1787 30.5356 19.2323C31.2856 18.8037 31.8213 18.1073 32.0892 17.3037C31.3927 17.7323 30.6427 18.0002 29.8392 18.1609C29.1963 17.4645 28.2856 17.0359 27.3213 17.0359C25.3927 17.0359 23.7856 18.5895 23.7856 20.5716C23.7856 20.8395 23.8392 21.1073 23.8927 21.3752C20.9463 21.2145 18.3749 19.8216 16.607 17.6787C16.2856 18.2145 16.1249 18.8037 16.1249 19.4466C16.1249 20.6787 16.7677 21.7502 17.6784 22.393C17.0892 22.393 16.5534 22.2323 16.0713 21.9645V22.018C16.0713 23.7323 17.3034 25.1252 18.9106 25.4466C18.5892 25.5002 18.3213 25.5537 17.9999 25.5537C17.7856 25.5537 17.5713 25.5537 17.357 25.5002C17.7856 26.893 19.1249 27.9109 20.6249 27.9645C19.4463 28.9287 17.8927 29.4645 16.232 29.4645C15.9642 29.4645 15.6427 29.4645 15.3749 29.4109C16.982 30.3752 18.857 30.9645 20.8392 30.9645C27.3213 30.9645 30.857 25.6073 30.857 20.9466C30.857 20.7859 30.857 20.6252 30.857 20.518C31.4999 19.9823 32.0892 19.393 32.5713 18.6966Z",
    fill: "#22252D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(15.4285 15.4287)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhitebk);
export default __webpack_public_path__ + "static/media/twitter_whitebk.d2d34b386bdc3ab45c1902597df7d0e8.svg";
export { ForwardRef as ReactComponent };